import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';

const columns = [{
  Header: 'Date Ordered',
  id: 'date_ordered',
  accessor: row => moment(row.date).format('MMMM Do, YYYY'),
  width: 150,
}, {
  Header: 'Item Name',
  accessor: 'name',
}, {
  Header: 'Supplier',
  accessor: 'supplier_name',
}, {
  Header: 'Link',
  accessor: 'order_id',
  width: 150,
  Cell: ({ value }) => <Link to={`/corporate/history/order/${value}`}>View Order</Link>,
  includeInExport: false
}];


const ItemTable = ({ items, includeExport }) => (
  <Table
    actions={includeExport && (
      <div className='u-paddingTop10'>
        <ColumnExportButton
          filename='Vetcove_Linked_Item_Table.csv'
          data={items}
          columns={columns}
        >
          Download
        </ColumnExportButton>
      </div>
    )}
    size='small'
    columns={columns}
    data={items}
    pageSize={_.size(items) || 10}
    showPagination={false}
  />
);

ItemTable.propTypes = {
  items: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default ItemTable;
